<template>
    <nuxt-link 
        v-if="author"
        :to="$prismic.linkResolver(author)" 
        class="author-wrapper"
    >
        <prismic-image 
            class="author-image"
            :img="author.data.image"
            w="30"
        />
        <div 
            v-if="$validateText(text)"
            class="author-text" 
            v-html="text"     
        />
    </nuxt-link>
</template>

<script>
export default {
    props: {
        author: {
            type: Object,
            required: false,
            default: null
        },
        text: {
            type: String,
            required: false,
            default: null
        },
    }
};
</script>